import { clearDisplayCaches } from './db';

// Evento que las pantallas escuchan para vaciar sus cachés en memoria
// (bundleSumCache de Positions, monthDayCache del calendario, etc.).
export const CLEAR_CACHES_EVENT = 'app:clear-caches';

// Borra todo rastro de datos del usuario anterior al cambiar de sesión:
//   1) Cachés en memoria de las pantallas (via evento) — instantáneo.
//   2) IndexedDB de visualización (positions / cargoDetails).
//   3) Caché de respuestas de API del Service Worker (`api-v1`): guarda las
//      respuestas por URL, que son distintas por usuario → es la causa
//      principal de que se vieran datos del usuario anterior.
// NO toca la cola offline pendiente (pendingDetails) para no perder trabajo
// sin sincronizar.
export async function clearCachedUserData(): Promise<void> {
  try {
    window.dispatchEvent(new Event(CLEAR_CACHES_EVENT));
  } catch { /* no-op */ }

  const tasks: Promise<unknown>[] = [clearDisplayCaches().catch(() => {})];
  if (typeof caches !== 'undefined') {
    tasks.push(caches.delete('api-v1').catch(() => false));
  }
  await Promise.allSettled(tasks);
}
